import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as __ from 'lodash';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-new-compnay-page',
  templateUrl: './new-compnay-page.component.html',
  styleUrls: ['./new-compnay-page.component.scss']
})
export class NewCompnayPageComponent implements OnInit {

  fortunecompnies: any
  industrydata: any
  typeahead_search: FormControl = new FormControl(null)
  typeaheaddata: any;
  searcherror: boolean = false;
  industryCount:number=4
  private typeAheadSubject = new Subject<{ event: Event }>();

  constructor(private companyinsightsservice: CompanyInsightsService, private router: Router, private personSearchService: PersonSearchService) { }

  ngOnInit(): void {
    this.getfortunecompanies();
    this.getaggregateIndustry()
    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event }) => {
      this.getTypeaheads(event);
    });
  }

   // Call this function whenever the user types something
   onTypeAheadSearch(event: Event) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event });
  }
  
  getfortunecompanies() {
    let payload = {
        startindex: 0,
        resultsize: 4,
        searchviaboolean: true,
        booleanquery: "*",
        industries: [],
        locations: [],
        companysizes: [],
        companybuckettypes: ["Fortun500"]
   }
    this.companyinsightsservice.getRecommendedcompanies(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.fortunecompnies = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
      }
    })
  }

  getaggregateIndustry(type?:any) {
   let payload =  {
      startindex: 1,
      resultsize: 4,
      searchviaboolean: true,
      booleanquery: "*",
      industries: [],
      locations: [],
      companysizes: [],
      aggregatetype: "industry",
      aggregatescount:this.industryCount + 4,
  }

  this.companyinsightsservice.getIndustryAggregates(payload).subscribe((res:any)=>{
    if(res.status == "success") {
      
      this.industrydata = this.chunkArray(res.data.aggregations.industries, 4)
      // this.industrydata = res.data.aggregations.industries
      this.getTopCompaniesForIndustry();
    }
  })
  
  }
 
  getTypeaheads(event) {
    this.searcherror = false
    const input = event.target.value
    this.companyinsightsservice.getCompanyTypeaheads(input).subscribe((res:any)=>{
      // this.typeaheaddata = res.data
      const companyList = res.data;
      this.personSearchService.getCompanyLogo({ companynames: companyList.map(c => c.value)}).subscribe((response: any) => {
        this.typeaheaddata = companyList.map(c => ({ ...c, companylogo: response.message.filter(r => r.name === c.value)[0]?.companylogo }));
      });
    })
  }

  redirecttoAllListing() {
    this.searcherror = false
    if(this.typeaheaddata.length > 0) {
      const inputkeyword = this.typeaheaddata.filter(x=>x.value.toLowerCase() == this.typeahead_search.value.toLowerCase())
      if(inputkeyword.length > 0) {
        if(this.typeahead_search.value) 
        this.router.navigate(['/company-list'], { queryParams: {keyword: this.typeahead_search.value } })
      } else {
        this.searcherror = true;
      }
    } else {
      this.router.navigate(['/company-list'])
    }

  }

  

  selectTypeahead(data) {
    this.typeahead_search.patchValue(data.value);
    if(data.id) {
      this.router.navigate([`/company-details/${data.id}`])    
    } else 
    this.redirecttoAllListing();

  }

  redirecttoCompanydetails(industry) {
    this.router.navigate(['/company-list'], { queryParams: {industry: industry } })
  }

  redirectToCompanyDetailsPage(company) {
    this.router.navigate([`/company-details/${company.id}`])
  }


redirecttocompany() {
  this.router.navigate(['/company-list'])
}
  getIndustryIcon(industryName){
    let iconName = GlobalService.getIndustryIcon(industryName)
    return `text-webbtree-green fa-solid fa-${iconName}`
  }

  getTopCompaniesForIndustry(){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
   let payload  = {"startindex":0,"resultsize":4,"searchviaboolean":true,
   "booleanquery":"*","industries":[],"locations":[],"companysizes":[], "islogorequired": true}
    // console.log(this.industrydata, 'this.industrydatathis.industrydatathis.industrydata')
    
    let clonedIndustryData = __.cloneDeep(this.industrydata.flat())
    let industries = clonedIndustryData.map(x => x.key)   

    industries.forEach(ind => {
    payload.industries = [ind]

      this.companyinsightsservice.getRecommendedcompanies(payload).subscribe((res:any)=>{
        if(res.status == 'success'){
          const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
          //loadn[0].style.display = 'block'
          let results = res.data.results
          const logosByIndustry = {};
          // Populate the logosByIndustry object
          results.forEach(item => {
              if (industries.includes(item.industry)) {
                  if (!logosByIndustry[item.industry]) {
                      logosByIndustry[item.industry] = [];
                  }
                  if(logosByIndustry[item.industry] && logosByIndustry[item.industry].length < 4){
                    if(item && item.companylogo){
                      logosByIndustry[item.industry].push(item.companylogo);
                    }
                  }
              }
          });
  
          clonedIndustryData.forEach(item => {
              if (logosByIndustry.hasOwnProperty(item.key)) {
                  item.logos = logosByIndustry[item.key];
              }
          });
  
          this.industrydata = this.chunkArray(clonedIndustryData, 4)
        }
      })
    });
  }

  chunkArray(array: any[], size: number): any[] {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }
  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'companyname': {
        if (!(this.typeahead_search && this.typeahead_search.value && this.typeahead_search.value.length >= maxLength)) {
          this.typeaheaddata = []
        }
        break;
      }
    }
  }
}

